import SC from "components/Stacker/constants/StackerConstants"
import SPC from "components/Stacker/constants/SearchPageConstants"

export const initialState = {
  addedStack: [],
  isAppLoaded: false,
  isFilterOpen: false,
  isProductListLoaded: false,
  isRearrange: false,
  isReviewing: false,
  isPreviewing: false,
  isStackerLoaded: false,
  isStackerReady: true,
  loadedSize: 0,
  pageSize: 40,
  pagination: {
    currentPage: -1,
    pageSize: 0,
    totalPages: 0,
    totalResults: 0,
  },
  pendingStack: [],
  products: [],
  productItemLoaded: 0,
  refiners: {},
  refinerMap: [],
  wasLoaded: false,
}

export default function stackerReducer(previousState = initialState, action) {
  switch (action.type) {
    case SPC.SEARCH_SUCCEED:
      return {
        ...previousState,
        pagination: {
          // ...action.payload.res.pagination
          currentPage: parseInt(action.payload.res.pagination.currentPage, 10),
          pageSize: parseInt(action.payload.res.pagination.pageSize, 10),
          totalPages: parseInt(action.payload.res.pagination.totalPages, 10),
          totalResults: parseInt(
            action.payload.res.pagination.totalResults,
            10
          ),
        },
      }
    case SC.CLEAR_PRODUCTS: {
      return {
        ...previousState,
        products: [],
        loadedSize: 0,
        productItemLoaded: 0,
        isProductListLoaded: false,
        pagination: initialState.pagination,
      }
    }
    case SC.UPDATE_PRODUCTS: {
      const products = action.payload
      // if (
      //   products.length > 0 &&
      //   previousState.products.findIndex((p) => p.code === products[0].code) >=
      //     0
      // ) {
      //   return previousState
      // }
      // const updatedProducts =
      //   previousState.pagination &&
      //   previousState.prevPagination &&
      //   previousState.pagination.currentPage >
      //     previousState.prevPagination.currentPage
      //     ? [...previousState.products, ...products]
      //     : products

      const updatedProducts =
        previousState.pagination.currentPage > 0
          ? [...previousState.products, ...products]
          : products
      const resetProductListLoaded = previousState.pagination.currentPage >= 0

      //const resetProductListLoaded = updatedProducts.length > 0 //previousState.pagination.currentPage >= 0
      return {
        ...previousState,
        products: updatedProducts,
        loadedSize: products.length,
        productItemLoaded: 0,
        isProductListLoaded: resetProductListLoaded,
      }
    }
    case SC.PRODUCTS_NEXT_PAGE: {
      const page = previousState.pagination.currentPage + 1
      if (page + 1 > previousState.pagination.totalPages) {
        return previousState
      }
      return {
        ...previousState,
        pagination: { ...previousState.pagination, currentPage: page },
      }
    }
    case SC.PAGINATION_RESET:
      return {
        ...previousState,
        isProductListLoaded: false,
        productItemLoaded: 0,
        pagination: initialState.pagination,
      }
    case SC.ADD_PENDING_STACK: {
      const { pendingStack } = previousState
      return {
        ...previousState,
        pendingStack: [...pendingStack, action.payload],
      }
    }
    case SC.SET_PENDING_STACK:
      return { ...previousState, pendingStack: action.payload }
    case SC.ADD_ADDED_STACK: {
      const { addedStack } = previousState
      return { ...previousState, addedStack: [...addedStack, action.payload] }
    }
    case SC.SET_ADDED_STACK:
      return { ...previousState, addedStack: action.payload }
    // Due to data structure, these are effectively the same operation
    // still, provide separate actions for debugging, etc
    case SC.REFINER_ADD:
    case SC.REFINER_METAL_CHANGE:
    case SC.REFINER_SIZE_CHANGE:
      return {
        ...previousState,
        refiners: { ...previousState.refiners, ...action.payload },
      }
    case SC.REFINER_MAP:
      return {
        ...previousState,
        refinerMap: [...previousState.refinerMap, action.payload],
      }
    case SC.REFINER_RESET:
      //TODO: something in portable isn't working when this is reset for now
      //return { ...previousState }
      return { ...previousState, refiners: {}, refinerMap: [] }
    case SC.REFINER_SWATCH_CHANGE:
      if (!previousState.isReviewing) return previousState
      return {
        ...previousState,
        refiners: { ...previousState.refiners, ...action.payload },
      }
    case SC.REVIEW_SELECTION:
      return {
        ...previousState,
        isReviewing: action.payload,
        isPreviewing: false,
      }
    case SC.PREVIEW_SELECTION:
      return {
        ...previousState,
        isPreviewing: action.payload,
        isReviewing: false,
      }
    case SC.SET_LOAD_STATUS:
      return { ...previousState, isAppLoaded: action.payload }
    case SC.SET_FILTER_OPEN:
      return { ...previousState, isFilterOpen: action.payload }
    case SC.SET_STACKER_READY:
      return { ...previousState, isStackerReady: action.payload }
    case SC.STACKER_REARRANGE:
      return { ...previousState, isRearrange: action.payload }
    case SC.STACKER_RESET:
      return { ...previousState, ...initialState }
    case SC.STACKER_LOADED: {
      const isStackerLoaded = action.payload
      const isLoaded = previousState.isProductListLoaded && isStackerLoaded
      return { ...previousState, isStackerLoaded, isAppLoaded: isLoaded }
    }
    case SC.PRODUCT_ITEM_LOADED:
      // const { currentPage } = previousState.pagination;
      // const loadedCount = previousState.productItemLoaded + 1;

      // let isProductListLoaded = currentPage !== -1;
      // if (currentPage === 0 && loadedCount === previousState.loadedSize) {
      // 	isProductListLoaded = true;
      // }

      // let isAppLoaded = currentPage >= 0;
      // if (
      // 	(currentPage >= 0 && isProductListLoaded) ||
      // 	previousState.wasLoaded
      // ) {
      // 	isAppLoaded = true;
      // 	return {
      // 		...previousState,
      // 		productItemLoaded: loadedCount,
      // 		isProductListLoaded,
      // 		isAppLoaded,
      // 		wasLoaded: isAppLoaded || previousState.wasLoaded
      // 	};
      // }
      // return {
      // 	...previousState,
      // 	productItemLoaded: loadedCount,
      // 	isProductListLoaded,
      // };
      if (!previousState.isAppLoaded) {
        return {
          ...previousState,
          isProductListLoaded: true,
          isAppLoaded: true,
          wasLoaded: true,
        }
      }
      return previousState

    default:
      return previousState
  }
}
